module.exports = __webpack_public_path__ + "static/roboto-mono-v7-latin-500-6221bb5e9ca6f51a91ebcbe89ad10361.woff2";